<template>
  <div>
    <section class="section">
      <div class="container">
        <TituloPrincipal :titulo="titulo" :subtitulo="subtitulo"/>
        <router-link :to="{name: 'inicio'}" class="button is-secundary">Volver al Inicio</router-link>
      </div>
    </section>
    <Redes/>
    <Promo/>
  </div>
</template>

<script>
import Promo from '@/components/Promo.vue'
import TituloPrincipal from '@/components/TituloPrincipal.vue'
import Redes from '@/components/Redes.vue'

export default {
  name: 'Error404',
  data () {
    return {
      titulo: 'Error 404',
      subtitulo: 'Página no encontrada'
    }
  },
  components: {
    TituloPrincipal,
    Promo,
    Redes
  }
}
</script>
